import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthContextComponent";
import { useNavigate, useLocation } from "react-router-dom";
import { GrLogout } from "react-icons/gr";
import { ROUTES } from "../lib/enums/Route";
import useUserLogin from "../hooks/UserLoginhook";
import { useWebSocketNotifications } from "../hooks/WebSocketHook";
import { useBalance } from "./BalanceContext";

const LogoutButton: React.FC = () => {
  const { setLoggedIn, loggedIn } = useContext(AuthContext);
  const [isHovered, setIsHovered] = useState(false);
  const { customColor } = useUserLogin();
  const navigate = useNavigate();
  const location = useLocation();
  const { disconnectSocket } = useWebSocketNotifications();
  const { clearBalances } = useBalance();

  const handleLogout = (): void => {
    if (loggedIn) {
      setLoggedIn(false, "");
      disconnectSocket();
      clearBalances();
      sessionStorage.clear();
      navigate(ROUTES.LOGIN);
    }
  };

  useEffect(() => {
    if (!loggedIn && location.pathname !== "/") {
      setLoggedIn(true, "");
    }
  }, [loggedIn, location]);

  return (
    <button
      onClick={handleLogout}
      style={{ backgroundColor: isHovered ? customColor : "" }}
      className="flex items-center w-full gap-2 px-4 py-2 text-left text-gray-700 text-md hover:rounded-b-md hover:text-white"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <GrLogout /> Logout
    </button>
  );
};

export default LogoutButton;
